import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { OidcClientAuthService } from './oidc-client-auth.service';
import { OidcInterceptorService } from './oidc-interceptor.service';
import { SigninRedirectCallbackComponent } from './signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './signout-redirect-callback.component';

@NgModule({
  providers: [
    OidcClientAuthService,
    { provide: HTTP_INTERCEPTORS, useClass: OidcInterceptorService, multi: true },
  ],
  declarations: [SigninRedirectCallbackComponent, SignoutRedirectCallbackComponent],
})
export class OidcClientModule { }
